import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/shesha-functional-tests/adminportal/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/shesha-functional-tests/adminportal/node_modules/next-navigation-guard/dist/components/NavigationGuardProvider.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/shesha-functional-tests/adminportal/node_modules/next-navigation-guard/dist/components/NavigationGuardProviderContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/vsts/work/1/s/shesha-functional-tests/adminportal/src/app/app-provider.tsx");
